<template>
  <div class="organization-dropdown">
    <label class="organization-dropdown-label">Portfolio:</label>
    <Dropdown :options="organizations" :value="selectedOrganizationId" @input="onOrganizationChange" />
  </div>
</template>

<script>
import Dropdown from '@/components/common/Dropdown.vue';

export default {
  name: 'OrganizationDropdown',
  components: {
    Dropdown
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    organizations: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedOrganizationId: this.value
    };
  },
  watch: {
    value(newValue) {
      this.selectedOrganizationId = newValue;
    }
  },
  methods: {
    onOrganizationChange(organizationId) {
      this.selectedOrganizationId = organizationId;
      this.$emit('input', organizationId);
      this.$emit('change', organizationId);
    }
  }
};
</script>

<style lang="scss" scoped>
.organization-dropdown {
  display: flex;
  align-items: center;
  gap: 8px;

  .organization-dropdown-label {
    font-weight: 500;
    font-size: 0.9rem;
    color: var(--theme-on-surface);
    white-space: nowrap;
  }
}
</style>
